import { Http } from '@angular/http';
import { Builder } from 'xml2js';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class UspsService {
    private UspsAddress = new Subject();
    observeUspsAddress = this.UspsAddress.asObservable();
    private UspsErrorMessage = new Subject<string>();
    observeUspsErrorMessage = this.UspsErrorMessage.asObservable();

    constructor(private httpService: Http) {
    }

    ValidateAddressWithUSPS(address: any): Promise<any> {
        let FinalResult: any;
        //  Data
        let addressJson: any;
        if (!address.BillingShippingDifferent) {
            addressJson = {
                XAVRequest:{
                AddressKeyFormat: {
                    AddressLine: [address.StreetAddress,address.AdditionalAddress],
                    PoliticalDivision2: address.City,
                    PoliticalDivision1: address.SelectedState?address.SelectedState:address.State,
                    PostcodePrimaryLow: address.ZipCode,
                    PostcodeExtendedLow: "",
                    CountryCode: "US"
                }
            }
            };
        } else {
            addressJson = {
                XAVRequest:{
                AddressKeyFormat: {
                    AddressLine: [address.ShippingStreetAddress,address.ShippingAdditionalAddress],
                    PoliticalDivision2: address.ShippingCity,
                    PoliticalDivision1: address.SelectedShippingState?address.SelectedShippingState:address.ShippingState,
                    PostcodePrimaryLow: address.ShippingZipCode,
                    PostcodeExtendedLow: '',
                    CountryCode: 'US'
                }
            }
            };
        }
        
        return new Promise((resolve, reject) => {
               this.PostToGetResponseFromUSPSAPI(addressJson).subscribe((response: any) => {

                let jsonResult: any;
                jsonResult = JSON.parse(response._body);
                    FinalResult = jsonResult.Data.XAVResponse.Response.ResponseStatus;
                    try {

                        if (!jsonResult.Data.XAVResponse.hasOwnProperty('NoCandidatesIndicator')) {
                        let addressResult = jsonResult.Data.XAVResponse.Candidate.AddressKeyFormat;
                        if(!addressResult)
                        {
                            let resAddress = jsonResult.Data.XAVResponse.Candidate
                            .filter(element => 
                                element.AddressKeyFormat.AddressLine[1].toLowerCase() == addressJson.XAVRequest.AddressKeyFormat.AddressLine[1].toLowerCase());
                            if(resAddress && resAddress.length > 0)
                            {
                                addressResult=resAddress[0].AddressKeyFormat;
                            }
                            else
                            {
                                addressResult=jsonResult.Data.XAVResponse.Candidate[0].AddressKeyFormat;
                            }
                        }
                        let res={
                            Address:[
                                {Address1:[addressResult.AddressLine[0] ==undefined || addressResult.AddressLine[0].length == 1 ? addressResult.AddressLine:addressResult.AddressLine[0]],
                                Address2:[addressResult.AddressLine[0] ==undefined || addressResult.AddressLine[0].length == 1?"":
                            addressResult.AddressLine[1]],
                            City:[addressResult.PoliticalDivision2],
                            State:[addressResult.PoliticalDivision1],
                            Zip5:[addressResult.PostcodePrimaryLow]}
                        ]};
                            resolve(res.Address);
                        } else {
                            reject([{Error:[
                                {
                                    Description:["Address Not Found"]
                                }
                            ]}]);
                        }
                    } catch (e) {
                        reject([{Error:[
                            {
                                Description:["Invalid Address"]
                            }
                        ]}]);
                    }
            });
        });
    }


    FormUrlForUspsValidation(AddressJson: any) {
        let resultUrl: string;
        const builder = new Builder({
            normalize: true,
            headless: true,
            renderOpts: {
                'pretty': false
            }
        });
        let xmlResult: any;
        xmlResult = builder.buildObject(AddressJson);
        resultUrl =
        `${environment.USPSAPIURL}?API=Verify&XML=<AddressValidateRequest USERID="${environment.USPSUserID}" PASSWORD="${environment.USPSPassword}"> ${xmlResult}</AddressValidateRequest>`;
        return resultUrl;
    }

    GetResponseFromUSPSAPI(uspsUrl: string) {
        return this.httpService.get(uspsUrl);
    }


    PostToGetResponseFromUSPSAPI(data : any) {
        return this.httpService.post(`${environment.apiBaseUrl}/ShoppingCart/USPSAddressValidation`, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/usps.service.ts